import Level from './Level.vue';
export default Level;
